<template>
    <div class="parser-container">
        <v-file-input label="Upload DXF" outlined dense prepend-icon="mdi-file-cad" @change="previewFile()"></v-file-input>
        <download-csv v-if="fileUploaded" :data="csv" :fields="fields" :advancedOptions="advancedOptions">
            <v-btn :loading="loading" color="primary" :disabled="loading" class="ma-2 white--text"
                @click="loader = 'loading'">
                Download <v-icon right dark>
                    mdi-cloud-download
                </v-icon>
            </v-btn>
        </download-csv>
    </div>
</template>

<style scoped>
.parser-container {
    margin-top: 72px;
    padding: 16px;
}
</style>

<script>

import parse, { DxfParser } from 'dxf-parser';
import JsonCSV from 'vue-json-csv'


export default {
    components: {
        'download-csv': JsonCSV
    },
    data() {
        return {

            csv: [],
            advancedOptions: {
                header: false
            },
            fields: ['x', 'y'],
            loading: false,
            fileUploaded: false



        };
    },
    created() {



    },
    computed: {

    },
    methods: {

        previewFile() {
            const content = document.querySelector(".content");
            const [file] = document.querySelector("input[type=file]").files;
            const reader = new FileReader();

            reader.addEventListener(
                "load",
                () => {
                    //  content.innerText = reader.result;
                },
                false,
            );

            if (file) {
                this.fileUploaded = true;
                console.log(file);
                reader.readAsText(file);
                reader.onload = (e) => this.parseDXF(e);

            }


        },

        parseDXF(e) {

            let fileText = e.target.result;
            let parser = new DxfParser();
            let dxf = null;
            try {
                dxf = parser.parseSync(fileText);
            } catch (err) {
                return console.error(err.stack);
            }

            let segments = this.calculateDistances(dxf);
            console.log(segments)
            this.csv = this.formatCoordinatesForCSV(segments);





        },

        calculateDistances(dxf) {

            let entities = dxf.entities;

            return entities.map(entity => {
                if (entity.type === "LINE") {
                    const v1 = entity.vertices[0];
                    const v2 = entity.vertices[1];
                    const distance = Math.sqrt(
                        Math.pow((v2.x - v1.x), 2) +
                        Math.pow((v2.y - v1.y), 2) +
                        Math.pow((v2.z - v1.z), 2)
                    );
                    return {
                        startPoint: v1,
                        endPoint: v2,
                        distance: distance
                    };
                }
            }).filter(line => line !== undefined);
        },

        formatCoordinatesForCSV(segments) {

            const formatPoint = (point) => `${point.x.toFixed(1)},${point.y.toFixed(1)}`;

            let formattedCoordinates = [];

            segments.forEach((segment, index) => {


                console.log(segment)

                if (index === 0) {
                    formattedCoordinates.push(segment.startPoint);
                }

                formattedCoordinates.push(segment.endPoint);

            });

            return formattedCoordinates;
        },

        prepareForExport(segments) {

            let data = [];
            segments.forEach((segment, index) => {

                console.log('test' + segment)

                if (index !== 0) {

                    data.push(
                        { segment }
                    )
                }
            });

            console.log(data)

            return data;



        }





    }
};
</script>